import { Formik } from 'formik';
import React from 'react';

import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteDispositionModal({
  refetchToggle,
  enqueueSnackbarWithStyles,
  selected,
  handleClose,
  show,
  userAtom,
  setUserAtom,
  mutation,
}) {
  // useRecoilValue(deleteDisposition);
  // const [, setDeleteDisp] = useRecoilState(deleteDispo);

  // function handleDelete() {
  //   setDeleteDisp(props.dispoId);
  //   props.handleClose();
  // }
  return (
    <Formik
      onSubmit={async (values, actions) => {
        const deletedDispos = [];
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              call: methodNameEnum.DELETE_DISPOSITION,
              apikey: userAtom.contents.apikey,
              businessid: userAtom.contents.businessid,
              dispositionid: values.selected[i].id,
            };
            const dispositionName = values.selected[i].disposition;
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_DISPOSITION,
              payload: data,
            });

            if (!response?.data?.success) {
              let message = `Looks like we encountered an error deleting "${dispositionName}" disposition`;
              let severity = 'error';
              let cadenceMessage = '';
              let webhooksMessage = '';
              let powerlistMessage = '';

              const errorOnValidate = response?.data?.errorOnValidate;
              if (
                errorOnValidate?.errorType?.includes(
                  'FK_CADENCE__BUSINESS_DISPOSITIONS'
                ) &&
                errorOnValidate?.entities?.cadences
              ) {
                const cadences = errorOnValidate.entities?.cadences;
                cadenceMessage = (
                  <div>
                    Cannot remove disposition "{dispositionName}" since it's
                    used in the following Cadences:
                    <ul>
                      {cadences.map((cadence) => (
                        <li key={cadence.cadenceId}>
                          <a
                            href={`/manage/cadences/${cadence.cadenceId}/edit`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: 'white',
                              textDecoration: 'underline',
                            }}
                          >
                            {cadence.cadenceName}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
                severity = 'warning';
              }

              if (
                errorOnValidate?.errorType?.includes(
                  'FK_POWERLISTS__BUSINESS_DISPOSITIONS'
                ) &&
                errorOnValidate?.entities?.powerlists
              ) {
                const powerlists = errorOnValidate.entities?.powerlists;
                powerlistMessage = (
                  <div>
                    Cannot remove disposition "{dispositionName}" since it's
                    used in the following Powerlists:
                    <ul>
                      {powerlists.map((powerlist) => (
                        <li key={powerlist.powerlistId}>
                          <a
                            href={`/manage/powerlists/${powerlist.powerlistId}/edit`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: 'white',
                              textDecoration: 'underline',
                            }}
                          >
                            {powerlist.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
                severity = 'warning';
              }

              if (
                errorOnValidate?.errorType?.includes(
                  'FK_WEBHOOKS__BUSINESS_DISPOSITIONS'
                ) &&
                errorOnValidate?.entities?.webhooks
              ) {
                const webhooks = errorOnValidate.entities?.webhooks;
                webhooksMessage = (
                  <div>
                    Cannot remove disposition "{dispositionName}" since it's
                    used in the following Webhooks:
                    <ul>
                      {webhooks.map((webhook) => (
                        <li key={webhook.webhookid}>
                          <a
                            href={`/manage/webhooks/${webhook.webhookid}/edit`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: 'white',
                              textDecoration: 'underline',
                            }}
                          >
                            {webhook.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
                severity = 'warning';
              }

              if (
                cadenceMessage != '' ||
                powerlistMessage != '' ||
                webhooksMessage != ''
              ) {
                message = (
                  <div>
                    {cadenceMessage} {powerlistMessage} {webhooksMessage}
                  </div>
                );
              }

              enqueueSnackbarWithStyles({
                message,
                alertProps: { severity },
              });
            }

            if (response?.data?.success) {
              deletedDispos.push(dispositionName);
            }
          }
        }
        handleClose();
        if (deletedDispos.length) {
          enqueueSnackbarWithStyles({
            message: `Successfully Deleted ${deletedDispos.length} Disposition(s)`,
            alertProps: { severity: 'success' },
          });
        }
        refetchToggle({});
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Disposition(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              size="xs"
              deleteDialog={true}
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                Disposition(s), this procedure is not reversible.
              </p>
              <p> Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
